import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { url } from "../../../../../Config/Config";
import Axios from "axios";
import { connect } from "react-redux";
import ViewFeeHead from "./ViewFeeHead/ViewFeeHead";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";

class FeeGroupDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feeGroupDetails: {},
      fees: [],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getGroupDetails(this.props.match.params.id);
    }
  }

  getGroupDetails = async (groupId) => {
    try {
      const response = await Axios.get(`${url}/api/fee-groups/${groupId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.feesGroup) {
        this.setState({
          feeGroupDetails: response.data.feesGroup,
          fees:
            response.data.feesGroup.fees.length !== 0
              ? response.data.feesGroup.fees
              : [],
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getGroupDetails(groupId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { feeGroupDetails } = this.state;
    console.log(this.props.match.url);
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Fee Grouping" refreshUrl={this.props.match.url} />
          <div style={{ display: "flex" }}>
            <ListItem divider style={{ marginRight: 5 }}>
              <b style={{ flexGrow: 1 }}>Class:</b>
              <div>{feeGroupDetails.studentClass}</div>
            </ListItem>
            {feeGroupDetails.faculty && (
              <ListItem divider style={{ marginRight: 5 }}>
                <b style={{ flexGrow: 1 }}>Faculty:</b>
                <div>{feeGroupDetails.faculty}</div>
              </ListItem>
            )}
            {feeGroupDetails.group && (
              <ListItem divider style={{ marginRight: 5 }}>
                <b style={{ flexGrow: 1 }}>Group:</b>
                <div>{feeGroupDetails.group}</div>
              </ListItem>
            )}
          </div>
          <ViewFeeHead
            fees={this.state.fees}
            groupId={this.props.match.params.id}
            getGroupDetails={this.getGroupDetails}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(FeeGroupDetails));
